<template>
  <div>
    <main class="main reception card-sales-connect">
      <div class="section top">
        <div class="top__headline">
          <h2>
            매출 내역 수집 및 한도
            <br />산출 중입니다.
          </h2>
        </div>
      </div>
      <div class="section progress-bar">
        <div class="progress-bar__loader"></div>
      </div>
    </main>
  </div>
</template>
<script>
export default {

}
</script>
